import React, { Fragment, useEffect, useRef, useState } from 'react'
import { useAppSelector, useAppDispatch } from '../../../app/hooks';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { KTIcon, toAbsoluteUrl } from '../../../_metronic/helpers';
import '../Project.css'
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import moment from 'moment';
import { t } from 'i18next';
import { addAccountProjectMilestone, updateAccountProjectMilestone, updateIsLoading, updateIsLoadingProjectSummary } from '../MilestoneSlice';
import { updateIsLoading as getMethodFromTasksSlice } from '../TasksSlice'
import CanvasLoader from '../../../common/CanvasLoader';
import { dateFormatByAccountCulture, getValueFromResource } from '../../../common/timeLiveFunction';

const objMilestoneValues = {
    milestoneDescription: '',
    startDate: new Date(),
    endDate: new Date(),
    isCompleted: false,
    isDisabled: false,
    isCanvasLoader: true,
    milestoneYup: { milestoneName: "" }
}

const MilestoneAddUpdate = (props: any) => {
    const { IsFromSummary } = props;
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const dispatch = useAppDispatch();
    const [milestoneValues, setMilestoneValues] = useState<any | ''>(objMilestoneValues);
    const { accountProjectId, accountProjectMilestoneId, milestoneList } = useAppSelector((state) => state.milestone);
    const { CurrentCultureDateFormat, cultureInfoName, dateInsertionFormat, calendarStartDay } = useAppSelector((state) => state.globalState);
    const defaultFocusRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        //accountProjectMilestoneId != 0 && 
        renderProjectMilestone();
    }, [accountProjectMilestoneId]);

    const renderProjectMilestone = () => {
        setMilestoneValues({
            ...milestoneValues,
            isCanvasLoader: true
        });
        if (accountProjectMilestoneId !== 0) {
            let objMilestone = milestoneList?.filter(x => x.AccountProjectMilestoneId === accountProjectMilestoneId)[0];
            setMilestoneValues({
                ...milestoneValues,
                milestoneYup: {
                    milestoneName: objMilestone?.MilestoneDescription,
                },
                milestoneDescription: objMilestone?.Comments,
                // startDate: new Date(objMilestone.StartDate),
                // endDate: new Date(objMilestone.MilestoneDate),
                startDate: dateFormatByAccountCulture(moment.parseZone(objMilestone.StartDate).format(dateInsertionFormat), cultureInfoName.toString()),
                endDate: dateFormatByAccountCulture(moment.parseZone(objMilestone.MilestoneDate).format(dateInsertionFormat), cultureInfoName.toString()),
                isCompleted: objMilestone.Completed === 'Yes' ? true : false,
                isDisabled: objMilestone.IsDisabled === 'Yes' ? true : false,
                isCanvasLoader: false
            });
        }
        else if (accountProjectMilestoneId === 0) {
            setMilestoneValues({
                ...milestoneValues,
                milestoneYup: {
                    milestoneName: "",
                },
                milestoneDescription: "",
                startDate: new Date(),
                endDate: new Date(),
                isCompleted: false,
                isDisabled: false,
                isCanvasLoader: false
            });
            if (defaultFocusRef.current) {
                defaultFocusRef.current.focus();
            }
        }
    }

    const onDateChange = (date: any, name: any) => {
        const { startDate, endDate } = milestoneValues;
        setMilestoneValues({
            ...milestoneValues,
            startDate: name == "startDate" ? date : startDate,
            endDate: name == "endDate" ? date : endDate
        });
    }

    const onSwitch = (data: any) => {
        let switchName = data.target.name;
        const { isCompleted, isDisabled } = milestoneValues;
        setMilestoneValues({
            ...milestoneValues,
            isCompleted: switchName == "isCompleted" ? isCompleted ? false : true : isCompleted,
            isDisabled: switchName == "isDisabled" ? isDisabled ? false : true : isDisabled
        });
    }

    const onAddUpdateMilestone = (validateValue: any) => {
        const { milestoneDescription, startDate, endDate, isCompleted, isDisabled } = milestoneValues;
        if (accountProjectMilestoneId == 0) {
            IsFromSummary ? dispatch(getMethodFromTasksSlice(true)) : dispatch(updateIsLoading(true));
            let addMilestone = {
                AccountProjectId: accountProjectId,
                MilestoneDescription: validateValue.milestoneName,
                Comments: milestoneDescription,
                StartDate: moment(startDate).format(dateInsertionFormat),
                MilestoneDate: moment(endDate).format(dateInsertionFormat),
                IsDisabled: isDisabled,
                Completed: isCompleted
            }
            dispatch(addAccountProjectMilestone(addMilestone)).then((result) => {
                if (result.payload.constructor == Array) {
                    IsFromSummary && dispatch(getMethodFromTasksSlice(false));
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    Number(result.payload[0].id) > 0 ?
                        ShowToast('Success', result.payload[0].message, "success", "toast-top-right") :
                        ShowToast('Error', "Milestone Added Failed", "error", "toast-top-right");
                } else {
                    ShowToast('Error', result.payload.message, "error", "toast-top-right");
                }
            }).catch((error) => {
            });

        } else {
            IsFromSummary ? dispatch(updateIsLoadingProjectSummary(true)) : dispatch(updateIsLoading(true));
            let editdMilestone = {
                MilestoneDescription: validateValue.milestoneName,
                Comments: milestoneDescription,
                StartDate: moment(startDate).format(dateInsertionFormat),
                MilestoneDate: moment(endDate).format(dateInsertionFormat),
                IsDisabled: isDisabled,
                Completed: isCompleted
            }
            dispatch(updateAccountProjectMilestone(editdMilestone)).then((result) => {
                if (result.payload.constructor == Array) {
                    IsFromSummary && dispatch(updateIsLoadingProjectSummary(false));
                    if (closeButtonRef.current) {
                        closeButtonRef.current.click();
                    }
                    Number(result.payload[0].id) > 0 ?
                        ShowToast('Success', result.payload[0].message, "success", "toast-top-right") :
                        ShowToast('Error', "Milestone Updated Failed", "error", "toast-top-right");
                } else {
                    ShowToast('Error', result.payload.message, "error", "toast-top-right");
                }
            }).catch((error) => {
            });
        }
    }

    return (
        <>
            <Formik
                initialValues={milestoneValues.milestoneYup}
                enableReinitialize={true}
                onSubmit={values => { onAddUpdateMilestone(values) }}
                validationSchema={yup.object().shape({
                    milestoneName: yup
                        .string()
                        .label('Milestone')
                        .required()
                })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <div className='card-body py-3' style={{ overflowY: 'auto' }}>
                            {milestoneValues.isCanvasLoader ? <CanvasLoader /> : <>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <label className="required fs-7 fw-normal mb-2">
                                            {/* {t('Milestone Name')} */}
                                            {getValueFromResource('Milestone Name',dispatch, t)}
                                            </label>
                                        <input
                                            value={values.milestoneName}
                                            type="text"
                                            className="form-control fs-7 fw-normal"
                                            placeholder=
                                            // {t('Milestone')}
                                            {getValueFromResource('Milestone',dispatch, t)}
                                            autoCapitalize="none"
                                            onChange={handleChange('milestoneName')}
                                            ref={defaultFocusRef}
                                            onBlur={() => setFieldTouched('milestoneName')}
                                        />
                                        <div>
                                            {touched.milestoneName && errors.milestoneName &&
                                                <p className='errorMsg'>{errors.milestoneName as string}</p>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className='row spacingBetweenRows'>
                                    <div className="col-md-12">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t('Milestone Description')} */}
                                            {getValueFromResource('Milestone Description',dispatch, t)}
                                            </label>
                                        <textarea
                                            value={milestoneValues.milestoneDescription}
                                            name="milestoneDescription"
                                            className="form-control fs-7 fw-normal"
                                            rows={4}
                                            onChange={(e) => setMilestoneValues({
                                                ...milestoneValues,
                                                milestoneDescription: e.target.value
                                            })}
                                        >
                                        </textarea>
                                    </div>
                                </div>
                                <div className='row spacingBetweenRows'>
                                    <div className="col-md-6">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t('Start Date')} */}
                                            {getValueFromResource('Start Date',dispatch, t)}
                                            </label>
                                        <div className="wrapper">
                                            <DatePicker
                                                selected={milestoneValues.startDate}
                                                onChange={(date) => onDateChange(date, "startDate")}
                                                calendarStartDay={calendarStartDay}
                                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                dateFormat={CurrentCultureDateFormat.toString()}
                                            >
                                            </DatePicker>
                                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t('When is it due?')} */}
                                            {getValueFromResource('When is it due?',dispatch, t)}
                                            </label>
                                        <div className="wrapper">
                                            <DatePicker
                                                selected={milestoneValues.endDate}
                                                onChange={(date) => onDateChange(date, "endDate")}
                                                calendarStartDay={calendarStartDay}
                                                className="form-control form-control-dark btn-icon-dark btn-text-dark fs-7 fw-normal"
                                                dateFormat={CurrentCultureDateFormat.toString()}
                                            >
                                            </DatePicker>
                                            <i className="insideField-Icons ki-outline ki-calendar text-gray"></i>
                                        </div>
                                    </div>
                                </div>
                                <div className='row spacingBetweenRows'>
                                    <div className="col-md-6">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t(`Completed`)} */}
                                            {getValueFromResource('Completed',dispatch, t)}
                                            </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                            <input
                                                className="form-check-input h-20px w-30px"
                                                type='checkbox'
                                                name='isCompleted'
                                                checked={milestoneValues.isCompleted}
                                                onChange={(e) => { onSwitch(e) }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label fs-7 fw-normal mb-2">
                                            {/* {t(`Disabled`)} */}
                                            {getValueFromResource('Disabled',dispatch, t)}
                                            </label>
                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                            <input
                                                className="form-check-input h-20px w-30px"
                                                type='checkbox'
                                                name='isDisabled'
                                                checked={milestoneValues.isDisabled}
                                                onChange={(e) => { onSwitch(e) }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                            }
                            {Object.keys(errors).length > 0 && (
                                <div className="mt-3 alert alert-danger">
                                    <strong>
                                        {/* {t('Error Summary')}: */}
                                        {getValueFromResource('Error Summary',dispatch, t)}:
                                        </strong>
                                    <ul>
                                        {Object.keys(errors).map((fieldName, index) => (
                                            <li key={index}>{errors[fieldName] as string}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className='card-footer pt-4'>
                            <div className='d-flex flex-end'>
                                <button
                                    ref={closeButtonRef}
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                                    id="kt_OffCanvas"
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel',dispatch, t)}
                                </button>
                                <button
                                    className='btn btn-sm btn-primary'
                                    type='button'
                                    data-kt-element='send'
                                    onClick={() => handleSubmit()}
                                    disabled={!isValid}
                                >
                                    {/* {t('Save')} */}
                                    {getValueFromResource('Save',dispatch, t)}
                                </button>
                            </div>
                        </div>
                    </Fragment>
                )}
            </Formik>
        </>
    )
}

export default MilestoneAddUpdate